export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1634_.2f21bd0b.jpg";